import Sprite from "app/components/sprite";
import { toast } from "react-toastify";

const ShareButtons = ({ withLabel, sectionRef, slug, title }) => {
  const commonBtnStyle = "flex items-center justify-center rounded-full";
  const btnWithLabel = `${commonBtnStyle} h-11 w-11 bg-ghostwhite lg:bg-white`;
  const btnWithoutLabel = `${commonBtnStyle} h-9 w-9 scale-75`;
  const divWithLabel =
    "grid grid-flow-row grid-cols-6 gap-y-5 py-4 md:w-3/5 md:pb-6 lg:w-full lg:grid-cols-3";
  const divWithoutLabel = "flex items-center gap-x-3 w-full xl:gap-x-4";
  const notify = () => toast.success("Link copied!");

  const btnStyle = withLabel ? btnWithLabel : btnWithoutLabel;

  return (
    <div ref={sectionRef} className="px-7 lg:px-0">
      {withLabel && (
        <p className="mb-4 pt-5 font-extrabold text-secondary-dark">Share</p>
      )}
      <div className={withLabel ? divWithLabel : divWithoutLabel}>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${slug}`}
          className={btnStyle}
        >
          <Sprite name="facebook" fill="#000" className="h-5 w-3" />
        </a>
        <a
          href={`http://twitter.com/intent/tweet?text=${slug}`}
          className={btnStyle}
        >
          <Sprite name="twitter" fill="#000" className="h-5 w-5" />
        </a>
        <a
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${slug}`}
          className={btnStyle}
        >
          <Sprite name="linkedin-v2" fill="#000" className="h-6 w-6" />
        </a>
        <a href={`mailto:?subject=${title}&body=${slug}`} className={btnStyle}>
          <Sprite name="email" fill="#000" className="h-7 w-7" />
        </a>
        <button
          className={btnStyle}
          onClick={() => {
            navigator.clipboard.writeText(decodeURIComponent(slug)).then(() => {
              notify();
            });
          }}
        >
          <Sprite name="copy" fill="#000" className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default ShareButtons;
